import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Dropzone from "react-dropzone";
import { Link } from "react-router-dom";
import { Input, Row, Col, Card, CardBody, Button, Spinner } from "reactstrap"; // Added Spinner

import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const defaultColor = "#000000"; // Default color for the color picker

const AddCommonForm = ({ labels, formikProps, onTranslateClickHandler, translationLoading, lastTranslatedField, isAddOrEdit }) => {
    const { t, i18n } = useTranslation();
    const isRTL = i18n.dir() === 'rtl'
    const today = new Date().toISOString().split("T")[0];
    

  // Destructure from formikProps for easier access
  const { values, errors, touched, handleChange, handleBlur, setFieldValue } = formikProps;


  const renderField = (item) => {
    const isDisabled = typeof item.disabled === 'function' ? item.disabled(isAddOrEdit) : !!item.disabled;
    const fieldValue = values[item.name] ?? "";

    switch (item.fieldName) {
      case "text-box":
        return (
            <Input
              type={"text"}
              id={item.name}
              name={item.name}
              placeholder={t(item.placeholder || item.labelName)}
              value={fieldValue}
              onChange={(e) => {
              const inputValue = e.target.value;
              
              // If it's RoleName field, allow only letters and spaces
              if (item.name === "ScreenNameAr" ) {
                const cleanedValue = inputValue.replace(/[^A-Za-z\u0600-\u06FF\s]/g, '');
                setFieldValue(item.name, cleanedValue);
              } else {
                handleChange(e);
              }
              }}
              maxLength={item.maxLength} 
				      minLength={item.minLength}
              onBlur={handleBlur}
              className="form-control"
              invalid={touched[item.name] && !!errors[item.name]}
              disabled={isDisabled}
              required={item.required}
            />
        );
      
      case "text-box-translate":
                return (
                  <div className="input-group"> 
                    <Input
                      type={"text"}
                      id={item.name}
                      name={item.name}
                      placeholder={t(item.placeholder || item.labelName)}
                      value={fieldValue}
                      onChange={(e) => {
                        const inputValue = e.target.value;
                        
                        // If it's RoleName field, allow only letters and spaces
                        if (item.name === "RoleNameEn" || item.name === "RoleNameAr") {
                          const cleanedValue = inputValue.replace(/[^A-Za-z\s]/g, '');
                          setFieldValue(item.name, cleanedValue);
                        } else {
                          handleChange(e);
                        }
                      }}            
                      maxLength={20}
                      minLength={2}
                      onBlur={handleBlur}
                      className="form-control"
                      invalid={touched[item.name] && !!errors[item.name]}
                      required={item.required}
                    />
                    {onTranslateClickHandler && item.translateTo && (
                      <Button
                        type="button"
                        onClick={() => onTranslateClickHandler(item.translateTo, fieldValue, setFieldValue, item.name)} // Pass item.name as sourceFieldName
                        disabled={!fieldValue || !fieldValue.trim() || translationLoading} // Disable if any translation is loading
                      >
                        {translationLoading && lastTranslatedField === item.name ? (
                          <Spinner size="sm" />
                        ) : (
                          <i className="ri-translate"></i>
                        )}
                      </Button>
                    )}
                  </div>
                );
        
      case "email-box":
        return (
          <Input
            type={"email"}
            id={item.name}
            name={item.name}
            placeholder={t(item.placeholder || item.labelName)}
            value={fieldValue}
            onChange={handleChange}
            onBlur={handleBlur}
            className="form-control"
            invalid={touched[item.name] && !!errors[item.name]}
            required={item.required}
          />
        );

      case "number":
        return (
          <Input
            type="tel"
            id={item.name}
            name={item.name}
            placeholder={t(item.placeholder || item.labelName)}
            value={fieldValue}
            onChange={handleChange} 
            onBlur={handleBlur}
            className="form-control"
            // maxLength={maxLength}
            invalid={touched[item.name] && !!errors[item.name]}
            required={item.required}
          />
        );

      case 'number-box':
        return (
            <Input
                type="text"
                style={{ textAlign: isRTL ? 'right' : 'left' }}
                id={item.name}
                name={item.name}
                placeholder={t(item.placeholder || item.labelName)}
                value={fieldValue}
                onChange={(e) => {
                    const inputValue = e.target.value;
                    let filteredValue = inputValue.replace(/[^0-9.]/g, '');

                    const parts = filteredValue.split('.');
                    if (parts.length > 2) {
                        filteredValue = parts[0] + '.' + parts.slice(1).join('');
                    }
                    setFieldValue(item.name, filteredValue);
                }}
                onBlur={handleBlur}
                className="form-control"
                invalid={touched[item.name] && !!errors[item.name]}
                disabled={isDisabled}
                required={item.required}
            />
        );


      case "text-box-translate":
        return (
          <div className="input-group"> 
            <Input
              type={"text"}
              id={item.name}
              name={item.name}
              placeholder={t(item.placeholder || item.labelName)}
              value={fieldValue}
              onChange={(e) => {
              const inputValue = e.target.value;
              
              // If it's RoleName field, allow only letters and spaces
              if (item.name === "ScreenNameEn" ) {
                const cleanedValue = inputValue.replace(/[^A-Za-z\s]/g, '');
                setFieldValue(item.name, cleanedValue);
              } else {
                handleChange(e);
              }
              }}             
              maxLength={item.maxLength} 
				      minLength={item.minLength}
              onBlur={handleBlur}
              className="form-control"
              invalid={touched[item.name] && !!errors[item.name]}
              required={item.required}
            />
            {onTranslateClickHandler && item.translateTo && (
              <Button
                type="button"
                onClick={() => onTranslateClickHandler(item.translateTo, fieldValue, setFieldValue, item.name)} // Pass item.name as sourceFieldName
                disabled={!fieldValue || !fieldValue.trim() || translationLoading} // Disable if any translation is loading
              >
                {translationLoading && lastTranslatedField === item.name ? (
                  <Spinner size="sm" />
                ) : (
                  <i className="ri-translate"></i>
                )}
              </Button>
            )}
          </div>
        );

      case "color-picker": // Added case for color picker
        return (
          <Input
            type="color"
            id={item.name}
            name={item.name}
            placeholder={t(item.placeholder || item.labelName)}
            value={fieldValue || defaultColor} // Use defaultColor if value is empty
            onChange={handleChange}
            onBlur={handleBlur}
            className="form-control form-control-color" // Use form-control-color class for styling
            invalid={touched[item.name] && !!errors[item.name]}
            required={item.required}
          />
        );
      default:
        return null;
    }
  };

  return (
    <Row>
      {labels.map((item) => {
        
        return (
          <Col sm={6} key={item.name}>
            <div className="mb-3">
              {item.labelName !== "Mobile" && (
                <label htmlFor={item.name} className="col-form-label">
                  {t(item.labelName)}
                  {item.required && <span className="text-danger"> *</span>}
                </label>
              )} 
              {/* Render the field */}
              {renderField(item)}
              {/* Display error for the main field */}
              {item.labelName !== "Mobile" && touched[item.name] && errors[item.name] && (
                <div className="text-danger mt-1" style={{ fontSize: "0.875rem" }}>{t(errors[item.name])}</div>
              )}
            </div>
          </Col>
        );
      })}
    </Row>
  );
}

export default AddCommonForm